{
  "$vuetify": {
    "badge": "Rozet",
    "noDataText": "Veri bulunamadı",
    "close": "Kapat",
    "open": "Aç",
    "loading": "Yükleniyor",
    "dataIterator": {
      "loadingText": "Yükleniyor"
    },
    "carousel": {
      "ariaLabel": {
        "delimiter": "ayırıcı"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Sayfa başına öğe:",
      "itemsPerPageAll": "Tümü",
      "pageText": "{0}-{1} arası, toplam {2}",
      "firstPage": "İlk Sayfa",
      "prevPage": "Önceki Sayfa",
      "nextPage": "Sonraki Sayfa",
      "lastPage": "Son Sayfa"
    },
    "pagination": {
      "showing": "Toplam {2} kayıttan {0} - {1} arası gösteriliyor",
      "ariaLabel": {
        "root": "kök",
        "previous": "önceki",
        "first": "ilk",
        "last": "son",
        "next": "sonraki",
        "currentPage": "geçerli sayfa",
        "page": "sayfa"
      }
    },
    "input": {
      "clear": "temizle",
      "appendAction": "sonradan eklenen işlem",
      "prependAction": "önceden eklenen işlem",
      "counterSize": "sayaç boyutu",
      "otp": "tek kullanımlık şifre"
    },
    "fileInput": {
      "counterSize": "sayaç boyutu"
    },
    "rating": {
      "ariaLabel": {
        "item": "öğe"
      }
    },
    "datePicker": {
      "header": "Tarih Seç",
      "items": [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık"
      ],
      "weekdays": [
        "Pazar",
        "Pazartesi",
        "Salı",
        "Çarşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi"
      ],
      "weekdaysShort": [
        "Paz",
        "Pzt",
        "Sal",
        "Çar",
        "Per",
        "Cum",
        "Cmt"
      ]
    },
    "colorPicker": {
      "ariaLabel": {
        "eyedropper": "Damlalık",
        "hexInput": "HEX girişi",
        "hueSlider": "Ton kaydırıcısı"
      }
    }
  },
  "Validation": {
    "required": "Bu alan zorunludur",
    "email": "Email alanı geçerli bir email olmalıdır",
    "password": "Alan en az 8 karakter, bir büyük harf, bir küçük harf, bir özel karakter ve bir rakam içermelidir",
    "confirmed": "Şifre ve Şifre Tekrarı uyuşmuyor",
    "phone": "Geçersiz telefon numarası formatı",
    "regex": "Regex alanı formatı geçersiz",
    "alpha": "Alpha alanı sadece alfabetik karakterler içerebilir",
    "url": "URL geçersiz",
    "length": "Karakter alanının uzunluğu {length} karakter olmalıdır.",
    "alphaDash": "Tüm Karakterler geçerli değil",
    "time": "Geçersiz saat formatı",
    "lengthMax": "En fazla {length} karakter giriniz",
    "lengthBetween": "{min} ve {max} arasında karakter giriniz",
    "integer": "Bu alan tam sayı olmalıdır.",
    "decimal": "Bu alan ondalık sayı olmalıdır.",
    "validNumber": "Geçerli bir sayı giriniz.",
    "min": "{min} veya daha büyük bir değer giriniz.",
    "max": "{max} veya daha küçük bir değer giriniz.",
    "lengthMin": "En az {length} karakter giriniz",
    "between": "{min} ile {max} arasında bir sayı giriniz.",
    "minTwoFields": "En az bir değer {min} veya daha büyük olmalıdır.",
    "sase": "Şase Geçerli değil",
    "startDateInline": "Başlangıç Tarihi {target} sonra olamaz",
    "endDateInline": "Bitiş Tarihi {target} önce olamaz"
  },
  "activeOptions": {
    "Hepsi": "Hepsi",
    "Aktif": "Aktif",
    "Pasif": "Pasif"
  },
  "projeFaturaTipList": {
    "Kısmı": "Kısmı",
    "Tam": "Tam"
  },
  "musteriTip": {
    "Alış-Satış": "Alış-Satış",
    "Alış": "Alış",
    "Satış": "Satış"
  },
  "paraTur": {
    "TL": "TL",
    "Euro": "Euro",
    "Dolar": "Dollar"
  },
  "satisDurum": {
    "Onayli": "Onaylı",
    "Bekliyor": "Bekliyor",
    "Iptal": "İptal",
    "Cayma": "Cayma"
  },
  "satisTip": {
    "Yok": "Yok",
    "case2": "case2",
    "case3": "case3"
  },
  "odemeSekli": {
    "1 Aylık": "1 Aylık",
    "3 Aylık": "3 Aylık",
    "6 Aylık": "6 Aylık",
    "12 Aylık": "12 Aylık"
  },
  "projeHourTypesList": {
    "Seçiniz": "Seçiniz",
    "General hours": "Genel Saatler",
    "AI-IS AI Models": "AI-IS AI Models",
    "AI-IS MM support": "AI-IS MM support",
    "AI-IS Commercial": "AI-IS Commercial",
    "AI-IS Non-commercial": "AI-IS Non-commercial",
    "Bee4GIS Commercial": "Bee4GIS Commercial",
    "Bee4GIS Non-commercial": "Bee4GIS Non-commercial"
  },
  "projeAltStatusList": {
    "Bekliyor": "Bekliyor",
    "İşlemde": "İşlemde",
    "Bitti": "Bitti"
  },
  "projeAltStatusAdminList": {
    "Bekliyor": "Bekliyor",
    "İşlemde": "İşlemde",
    "Bitti": "Bitti",
    "Gönderildi": "Gönderildi",
    "Onay": "Onay",
    "Kapalı": "Kapalı"
  },
  "projeAltUcretTurList": {
    "Seçiniz": "Seçiniz",
    "KM Fiyat": "KM Fiyat",
    "Saat Fiyat": "Saat Fiyat",
    "Sabit Fiyat": "Sabit Fiyat",
    "Adet Fiyat": "Adet Fiyat"
  },
  "medenidurumListe": {
    "Bilinmiyor": "Bilinmiyor",
    "Bekar": "Bekar",
    "Evli": "Evli",
    "Boşanmış": "Boşanmış",
    "Dul": "Dul"
  },
  "ogrenimListe": {
    "Bilinmiyor": "Bilinmiyor",
    "İlköğretim": "İlköğretim",
    "Ortaöğretim": "Ortaöğretim",
    "Lise": "Lise",
    "ÖnLisans": "ÖnLisans",
    "Lisans": "Lisans",
    "Yüksek Lisans": "Yüksek Lisans",
    "Doktora": "Doktora"
  },
  "kangrubuListe": {
    "Bilinmiyor": "Bilinmiyor",
    "A+": "A+",
    "A-": "A-",
    "B+": "B+",
    "B-": "B-",
    "AB+": "AB+",
    "AB-": "AB-",
    "0+": "0+",
    "0-": "0-"
  },
  "cinsiyetListe": {
    "Bilinmiyor": "Bilinmiyor",
    "Erkek": "Erkek",
    "Kadın": "Kadın"
  },
  "egitimTurList": {
    "Diploma": "Diploma",
    "Sertifika": "Sertifika",
    "Belge": "Belge",
    "Öğrenci": "Öğrenci"
  },
  "izinTurList": {
    "Yıllık ücretli izin": "Yıllık ücretli izin",
    "Ücretsiz izin": "Ücretsiz izin",
    "Mazeret izni": "Mazeret izni",
    "Diğer izinler": "Diğer izinler",
    "Rapor": "Rapor"
  },
  "izinTurGetList": {
    "Yıllık ücretli girişi": "Yıllık ücretli girişi",
    "Yıllık ücretli izin": "Yıllık ücretli izin",
    "Ücretsiz izin": "Ücretsiz izin",
    "Mazeret izni": "Mazeret izni",
    "Diğer izinler": "Diğer izinler",
    "Rapor": "Rapor"
  },
  "envanterStatusList": {
    "Yeni": "Yeni",
    "Aktif": "Aktif",
    "Zimmet": "Zimmet",
    "Tamirde": "Tamirde",
    "Depoda": "Depoda",
    "Demirbaş": "Demirbaş",
    "Kayıp": "Kayıp",
    "Pasif": "Pasif",
    "Satıldı": "Satıldı",
    "Hurda": "Hurda",
    "Diğer": "Diğer"
  },
  "komisyon_tur_liste": {
    "Komisyonsuz": "Komisyonsuz",
    "Ape Komisyon": "Ape Komisyon",
    "Sm Ape Komisyon": "Sm Ape Komisyon"
  },
  "yemekKartiTipi": {
    "Yok": "Yok",
    "Mobil": "Mobil Kart",
    "Fiziksel": "Fiziki Kart"
  },
  "Acil Durum": "Acil Durum",
  "Ad": "Ad",
  "Ad Soyad": "Ad Soyad",
  "Ad daha önceden kayıt edilmiş.": "Ad daha önceden kayıt edilmiş.",
  "Adet": "Adet",
  "Adres": "Adres",
  "Aktif Kayıt": "Aktif Kayıt",
  "Aktif/Pasif": "Aktif/Pasif",
  "Alış": "Alış",
  "Ana Sayfa": "Ana Sayfa",
  "Anket Başarıyla Gönderildi": "Anket başarıyla gönderildi.",
  "Anket Başlığı": "Anket Başlığı",
  "Anket Bilgileri": "Anket Bilgileri",
  "Anket Cevapları": "Anket Cevapları",
  "Anket Listesi": "Anket Listesi",
  "Anket Oluştur": "Anket Oluştur",
  "Anket Public": "Anket Public",
  "Anket Silindi": "Anket başarıyla silindi.",
  "Anket Sonuçları": "Anket Sonuçları",
  "Anket Soruları": "Anket Soruları",
  "Anket Yönetimi": "Anket Yönetimi",
  "Anket cevaplarınız başarıyla kaydedilmiştir.": "Anket cevaplarınız başarıyla kaydedilmiştir.",
  "Anket cevaplarınız kaydedildi. Teşekkürler!": "Anket cevaplarınız kaydedildi. Teşekkürler!",
  "Anket silindi.": "Anket silindi.",
  "Anketi Düzenle": "Anketi Düzenle",
  "Anketi Gönder": "Anketi Gönder",
  "Anketi Sil": "Anketi Sil",
  "Anketi Tamamla ve Gönder": "Anketi Tamamla ve Gönder",
  "Anketi göndermek istediğinize emin misiniz?": "Anketi göndermek istediğinize emin misiniz?",
  "Anketi Çöz": "Anketi Çöz",
  "Anketler": "Anketler",
  "Anketlerim": "Anketlerim",
  "Ara": "Ara",
  "Ara...": "Ara...",
  "Arama": "Arama",
  "Ayarları Güncelle": "Ayarları Güncelle",
  "Aygul Yazılım": "Aygul Yazılım",
  "Aygül Yazılım": "Aygül Yazılım",
  "Az Bulutlu": "Az Bulutlu",
  "Açık / Güneşli": "Açık / Güneşli",
  "Açık Uçlu": "Açık Uçlu",
  "Açık Uçlu (Metin)": "Açık Uçlu (Metin)",
  "Açıklama": "Açıklama",
  "Açıklama Metni (Cevapsız)": "Açıklama Metni (Cevapsız)",
  "Banka": "Banka",
  "Barkod": "Barkod",
  "Bas Saat": "Baş. Saat",
  "Baş Saat": "Baş Saat",
  "Baş.Tarih": "Başlangıç Tarihi",
  "Başarılı!": "Başarılı!",
  "Başlangıç": "Başlangıç",
  "Başlangıç Saat": "Başlangıç Saati",
  "Başlangıç Tarih": "Başlangıç Tarihi",
  "Başlangıç Tarihi Bitiş Tarihinden sonra olamaz": "Başlangıç Tarihi Bitiş Tarihinden sonra olamaz",
  "Başlık": "Başlık",
  "Belge Tür": "Belge Tür",
  "Bildirim başarıyla gönderildi.": "Bildirim başarıyla gönderildi.",
  "Bilgi Notu": "Bilgilendirme Notu",
  "Bilgiler": "Bilgiler",
  "Bilgiler Alınıyor": "Bilgiler Alınıyor",
  "Bilgiler Hatalı olabilir kontrol ediniz.": "Bilgiler Hatalı olabilir kontrol ediniz.",
  "Bilinmeyen Konum": "Bilinmeyen Konum",
  "Bit Saat": "Bitiş Saati",
  "Bit.Tarih": "Bitiş Tarihi",
  "Bitiş": "Bitiş",
  "Bitiş Saat": "Bitiş Saati",
  "Bitiş Saat Başlangıçdan Küçük Olamaz": "Bitiş Saat Başlangıçdan Küçük Olamaz",
  "Bitiş Tarih": "Bitiş Tarihi",
  "Bitiş Tarihi Başlangıç Tarihinden önce olamaz": "Bitiş Tarihi Başlangıç Tarihinden önce olamaz",
  "Bu alan zorunludur": "Bu alan zorunludur",
  "Bu ankete daha önce katılım sağladınız.": "Bu ankete daha önce katılım sağladınız.",
  "Bu cevabı silmek istediğinize emin misiniz?": "Bu cevabı silmek istediğinize emin misiniz?",
  "Bu gereksinimlerin karşılandığından emin olun": "Bu gereksinimlerin karşılandığından emin olun",
  "Bu müşterinin bu kodla kayıtı var.": "Bu müşterinin bu kodla kayıtı var.",
  "Bu soruyu cevaplamanız gerekmektedir.": "Bu soruyu cevaplamanız gerekmektedir.",
  "Bulunamadı, UTC gösteriliyor.": "Bulunamadı, UTC gösteriliyor.",
  "Bölge bulunamadı": "Bölge bulunamadı",
  "Bölüm": "Bölüm",
  "BİLİŞİM": "BİLİŞİM",
  "COMMENT": "YORUM",
  "Cep": "Cep",
  "Cevabınız": "Cevabınız",
  "Cevap": "Cevap",
  "Cevap (Seçenek)": "Cevap (Seçenek)",
  "Cevap Detayları": "Cevap Detayları",
  "Cevap Sayısı": "Cevap Sayısı",
  "Cevap yok": "Cevap yok",
  "Cevaplanmış anketler silinemez.": "Cevaplanmış anketler silinemez.",
  "Cevaplar": "Cevaplar",
  "Choose": "Seç",
  "Cinsiyet": "Cinsiyet",
  "Create an account": "Hesap Oluştur",
  "DEMİRBAŞ": "DEMİRBAŞ",
  "Daha Önce Katıldınız": "Daha Önce Katıldınız",
  "Dakika": "Dakika",
  "Data Yenile": "Data Yenile",
  "Bu tarihe mesai girilemez.": "Bu tarihe mesai girilemez.",
  "Detay": "Detay",
  "Detayları Gör": "Detayları Gör",
  "Diğer izinler": "Diğer izinler",
  "Doküman Kaydedildi": "Doküman başarıyla kaydedildi.",
  "Doküman Yüklenemedi": "Doküman yüklenirken hata oluştu.",
  "Doküman İçeriği": "Doküman İçeriği",
  "Doğrulama Yöntemi": "Doğrulama Yöntemi",
  "Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.": "Doğrulama kodu gönderilemedi. Lütfen tekrar deneyin.",
  "Doğum Tarihi": "Doğum Tarihi",
  "Durum": "Durum",
  "Düzeltme": "Düzeltme",
  "Düzenle": "Düzenle",
  "E-mail": "E-posta",
  "Ekle": "Ekle",
  "Eksik Bilgi var. Kontrol ediniz.": "Eksik Bilgi var. Kontrol ediniz.",
  "Eksik Seçenek": "Eksik Seçenek",
  "Email": "E-posta",
  "Email Sistemi": "Email Sistemi",
  "Email Şifresi": "Email Şifresi",
  "Emin misiniz?": "Emin misiniz?",
  "En Az 5 Dakika fark olmalı": "En Az 5 Dakika fark olmalı",
  "Enter your email and we'll send you instructions to reset your password": "Email adresinizi girin, size şifrenizi sıfırlamanız için talimatları göndereceğiz.",
  "Envanter Ad": "Envanter Adı",
  "Etiketle": "Etiketle",
  "Etiketler": "Etiketler",
  "Etkinlik": "Etkinlik",
  "Evet": "Evet",
  "Evet, Sil": "Evet, Sil",
  "Evet, gönder!": "Evet, gönder!",
  "Evlilik Tarihi": "Evlilik Tarihi",
  "Excel İndir": "Excel İndir",
  "Excel'e Aktar": "Excel'e Aktar",
  "Eğitim": "Eğitim",
  "Fakülte": "Fakülte",
  "Filtrele": "Filtrele",
  "Firma": "Firma",
  "Forgot Password?": "Şifrenizi mi Unuttunuz?",
  "Fotoğraf": "Fotoğraf",
  "Fotoğraf İşlemleri": "Fotoğraf İşlemleri",
  "Fırtına": "Fırtına",
  "GPS Yok": "GPS Yok",
  "Gece": "Gece",
  "Geen gegevens gevonden": "Veri bulunamadı",
  "Genel": "Genel",
  "Genel Bilgi": "Genel Bilgi",
  "Genel Durum Aylık Rapor": "Genel Durum Aylık Rapor",
  "Geçersiz doğrulama kodu.": "Geçersiz doğrulama kodu.",
  "Giriş": "Giriş",
  "Gizle": "Gizle",
  "Gönder": "Gönder",
  "Gün": "Gün",
  "Günaydın ☀️": "Günaydın ☀️",
  "Güncelle": "Güncelle",
  "Gündüz": "Gündüz",
  "Günün Tamamlanması": "Günün Tamamlanması",
  "Günün İlerlemesi": "Günün İlerlemesi",
  "Hafif Kar": "Hafif Kar",
  "Hafif Yağmur": "Hafif Yağmur",
  "Hafif Çiseleme": "Hafif Çiseleme",
  "Hafta": "Hafta",
  "Hava Açık": "Hava Açık",
  "Hava Durumu": "Hava Durumu",
  "Hava durumu bilgisi alınamadı.": "Hava durumu bilgisi alınamadı.",
  "Hava durumu servisine erişilemedi.": "Hava durumu servisine erişilemedi.",
  "Hava durumu verisi alınamadı.": "Hava durumu verisi alınamadı.",
  "Hayır": "Hayır",
  "Henüz anket bulunmuyor.": "Henüz anket bulunmuyor.",
  "Henüz cevap bulunmuyor.": "Henüz cevap bulunmuyor.",
  "Henüz cevap yok.": "Henüz cevap yok.",
  "Her hakkı saklıdır": "Her hakkı saklıdır",
  "Hissedilen": "Hissedilen",
  "Home": "Ana Sayfa",
  "Hour Types": "Saat Türleri",
  "Hours Type": "Hours Type",
  "Hoşgeldiniz {name}": "Hoşgeldiniz {name}",
  "IBAN": "IBAN",
  "Incoming Documents": "Gelen Belgeler",
  "Inkomende Documenten": "Gelen Belgeler",
  "KABLO": "KABLO",
  "KOLTUK": "KOLTUK",
  "KYS Paneli": "KYS Paneli",
  "Kalan Ücretli İzin Günü": "Kalan Ücretli İzin Günü",
  "Kalan İzin": "Kalan İzin",
  "Kan Grubu": "Kan Grubu",
  "Kanban": "Kanban",
  "Kapat": "Kapat",
  "Kar Yağışlı": "Kar Yağışlı",
  "Kategori Doküman Takip": "Kategori Doküman Takip",
  "Katılım Sayısı": "Katılım Sayısı",
  "Katılım detayları yüklenemedi.": "Katılım detayları yüklenemedi.",
  "Katılım silindi.": "Katılım silindi.",
  "Katılımlar yüklenirken hata oluştu.": "Katılımlar yüklenirken hata oluştu.",
  "Kaydet": "Kaydet",
  "Kayıt": "Kayıt",
  "Kayıt Yok!": "Kayıt Yok!",
  "Kimlik No": "Kimlik No",
  "Kod": "Kod",
  "Kod Proje": "Kod Proje",
  "Kod daha önceden kayıt edilmiş.": "Kod daha önceden kayıt edilmiş.",
  "Konu": "Konu",
  "Konum Aranıyor...": "Konum Aranıyor...",
  "Konum Bekleniyor...": "Konum Bekleniyor...",
  "Konum Bulunuyor...": "Konum Bulunuyor...",
  "Konum Hesaplanıyor...": "Konum Hesaplanıyor...",
  "Konum alınamadı.": "Konum alınamadı.",
  "Konum bilgisi alınamadı": "Konum bilgisi alınamadı",
  "Konum isteği zaman aşımına uğradı.": "Konum isteği zaman aşımına uğradı.",
  "Konumu Güncelle": "Konumu Güncelle",
  "Konumu Yenile": "Konumu Yenile",
  "Konumu Şimdi Kontrol Et": "Konumu Şimdi Kontrol Et",
  "Kopyala": "Kopyala",
  "Kullanici": "Kullanıcı",
  "Kullanıcı": "Kullanıcı",
  "Kullanıcı Mesai Süreleri": "Kullanıcı Mesai Süreleri",
  "Kurum/Okul": "Kurum/Okul",
  "Kırağı / Sis": "Kırağı / Sis",
  "Laravel Log": "Laravel Log",
  "Liste Döküman Takip": "Liste Döküman Takip",
  "Listeye Dön": "Listeye Dön",
  "MASA": "MASA",
  "MONİTÖR": "MONİTÖR",
  "MOUSE": "MOUSE",
  "MUTFAK": "MUTFAK",
  "Mail Sistemi": "Mail Sistemi",
  "Mazeret izni": "Mazeret izni",
  "Medeni Durum": "Medeni Durum",
  "Mesai": "Mesai",
  "Metin girilmedi": "Metin girilmedi",
  "Metre": "Metre",
  "Miktar": "Miktar",
  "Minimum 8 karakter uzunluğunda, büyük harf ve sembol !@#$%&*()": "Minimum 8 karakter uzunluğunda, büyük harf ve sembol !{'@'}#$%&*()",
  "Müşteri": "Müşteri",
  "NETWORK": "NETWORK",
  "NOTEBOOK": "NOTEBOOK",
  "Nem": "Nem",
  "No data available": "No data available",
  "Not": "Not",
  "Oluştur": "Oluştur",
  "Oluşturulma": "Oluşturulma",
  "Onay Tarih": "Onay Tarihi",
  "Otomatik hesaplanır (veya 1'den başlar)": "Otomatik hesaplanır (veya 1'den başlar)",
  "Overall": "Genel Durum",
  "Overall Rapor Aylık": "Overall Rapor Aylık",
  "PC": "PC",
  "PDF oluşturulurken hata": "PDF oluşturulurken hata oluştu.",
  "Paket": "Paket",
  "ParaTür": "Para Türü",
  "Parçalı Bulutlu": "Parçalı Bulutlu",
  "Pasif Kayıt": "Pasif Kayıt",
  "Pasif/Süresi Dolmuş": "Pasif/Süresi Dolmuş",
  "Password": "Şifre",
  "Performans": "Performans",
  "Personel": "Personel",
  "Personel Profil2": "Personel Profili 2",
  "Pertentage Opa Rapor": "Yüzde Operasyon Raporu",
  "Pertentage Oparator Rapor -": "Yüzde Operatör Raporu -",
  "Pertentage Rapor": "Yüzde Raporu",
  "Proje": "Proje",
  "Proje Alt": "Proje Alt Kategorisi",
  "Proje Tanıtım": "Proje Tanıtım",
  "Proje-Paket": "Proje-Paket",
  "Projealt": "Proje Alt Kategorisi",
  "Puan": "Puan",
  "Puan güncellendi.": "Puan güncellendi.",
  "Rapor Overall -": "Rapor Overall -",
  "Rapor Proje -": "Rapor Proje -",
  "Raporlar": "Raporlar",
  "Rüzgar": "Rüzgar",
  "SANDALYE": "SANDALYE",
  "STAND": "STAND",
  "Saat": "Saat",
  "Sabit Zaman": "Sabit Zaman",
  "Saniye": "Saniye",
  "ScheduleMonitor": "ScheduleMonitor",
  "Seçenek Ekle": "Seçenek Ekle",
  "Seçenek metni": "Seçenek metni",
  "Seçenekler": "Seçenekler",
  "Seçili Konum": "Seçili Konum",
  "Seçmeli sorularda en az 2 seçenek olmalıdır.": "Seçmeli sorularda en az 2 seçenek olmalıdır.",
  "Shortcut": "Shortcut",
  "Shortcut already exists": "Shortcut already exists",
  "Sicil No": "Sicil No",
  "Sil": "Sil",
  "Hafif Sağanak Yağış": "Hafif Sağanak Yağış",
  "Sağanak Yağış": "Sağanak Yağış",
  "Şiddetli Sağanak Yağış": "Şiddetli Sağanak Yağış",
  "Yoğun Çiseleme": "Yoğun Çiseleme",
  "Hafif Dondurucu Çiseleme": "Hafif Dondurucu Çiseleme",
  "Yoğun Dondurucu Çiseleme": "Yoğun Dondurucu Çiseleme",
  "Şiddetli Yağmur": "Şiddetli Yağmur",
  "Hafif Dondurucu Yağmur": "Hafif Dondurucu Yağmur",
  "Yoğun Dondurucu Yağmur": "Yoğun Dondurucu Yağmur",
  "Yoğun Kar Yağışlı": "Yoğun Kar Yağışlı",
  "Kar Taneleri": "Kar Taneleri",
  "Hafif Kar Sağanağı": "Hafif Kar Sağanağı",
  "Yoğun Kar Sağanağı": "Yoğun Kar Sağanağı",
  "Dolu Karışık Fırtına": "Dolu Karışık Fırtına",
  "Şiddetli Dolu Karışık Fırtına": "Şiddetli Dolu Karışık Fırtına",
  "Silme Onayı": "Silme Onayı",
  "Sisli": "Sisli",
  "Son Hareket": "Son Hareket",
  "Son Kontrol": "Son Kontrol",
  "Son güncel": "Son Güncellenme",
  "Sonuçlar": "Sonuçlar",
  "Soru": "Soru",
  "Soru Bazlı Analiz": "Soru Bazlı Analiz",
  "Soru Ekle": "Soru Ekle",
  "Soru Metni": "Soru Metni",
  "Soru Sayısı": "Soru Sayısı",
  "Soru Tipi": "Soru Tipi",
  "Spam'e Taşı": "Spam'e Taşı",
  "Status": "Durum",
  "Süre": "Süre",
  "Sıra": "Sıra",
  "TV": "TV",
  "Takip Kod": "Takip Kodu",
  "Takvim": "Takvim",
  "Takvim Doğum Günü Göster": "Takvim Doğum Günü Göster",
  "Tamamlanma Tarihi": "Tamamlanma Tarihi",
  "Tanıtım": "Tanıtım",
  "Tarayıcı desteği yok.": "Tarayıcı desteği yok.",
  "Tarih": "Tarih",
  "Tarih Aralığı": "Tarih Aralığı",
  "Taslak": "Taslak",
  "Taşı": "Taşı",
  "Tek Seçmeli": "Tek Seçmeli",
  "Tek Seçmeli (Radyo)": "Tek Seçmeli (Radyo)",
  "Telefon": "Telefon",
  "Temizle": "Temizle",
  "Teslim Tarih": "Teslim Tarih",
  "Teşekkürler!": "Teşekkürler!",
  "Tip": "Tip",
  "Toplam Cevap": "Toplam Cevap",
  "Toplam Katılımcı": "Toplam Katılımcı",
  "Toplam Puan": "Toplam Puan",
  "Toplam Puan:": "Toplam Puan:",
  "Tümü": "Tümü",
  "Tümünü Excel İndir": "Tümünü Excel İndir",
  "Tünaydın 👋": "Tünaydın 👋",
  "Tür": "Tür",
  "USB ETH": "USB ETH",
  "Undefined variable $tarih": "Undefined variable $tarih",
  "Uygulama çevrimdışı çalışmaya hazır.": "Uygulama çevrimdışı çalışmaya hazır.",
  "Uygulama İndir": "Uygulama İndir",
  "Varsayılan": "Varsayılan",
  "Veri bulunamadı": "Veri bulunamadı",
  "Veri yükleniyor...": "Veri yükleniyor...",
  "Veriliş Tarihi": "Veriliş Tarihi",
  "WEBCAM": "WEBCAM",
  "Webcam": "Webcam",
  "Word Dosyası Yükle": "Word Dosyası Yükle",
  "YAZICI": "YAZICI",
  "Yakınlık": "Yakınlık",
  "Yayında": "Yayında",
  "Yağmurlu": "Yağmurlu",
  "Yeni Anket Oluştur": "Yeni Anket Oluştur",
  "Yeni Güncelleme Mevcut!": "Yeni Güncelleme Mevcut!",
  "Yeni özellikleri ve düzeltmeleri görmek için sayfayı yenileyin.": "Yeni özellikleri ve düzeltmeleri görmek için sayfayı yenileyin.",
  "Yeni Şifre": "Yeni Şifre",
  "Yerel": "Yerel",
  "Yerel Saat": "Yerel Saat",
  "Yerel Saat Dilimi": "Yerel Saat Dilimi",
  "Yetkiniz bulunmuyor. Hata olduğunu düşünüyorsanız Admin'e Bilgi verin.": "Yetkiniz bulunmuyor. Hata olduğunu düşünüyorsanız Admin'e Bilgi verin.",
  "Your new password must be different from previously used passwords": "Yeni şifreniz daha önce kullandığınız şifrelerden farklı olmalıdır",
  "Yoğun Kar": "Yoğun Kar",
  "Yönetim": "Yönetim",
  "Yönetim Anket": "Yönetim Anket",
  "Yükleniyor...": "Yükleniyor...",
  "Yüzde": "Yüzde",
  "Yıl": "Yıl",
  "Yıllık ücretli girişi": "Yıllık ücretli girişi",
  "Yıllık ücretli izin": "Yıllık ücretli izin",
  "Zaman Dilimi": "Zaman Dilimi",
  "Zorunlu Cevap": "Zorunlu Cevap",
  "için gün bitimi": "için gün bitimi",
  "title alanı gereklidir.": "Başlık alanı gereklidir.",
  "welcome": "{title} Hoş Geldiniz! 👋🏻",
  "Çiseleme": "Çiseleme",
  "Çocuk Sayısı": "Çocuk Sayısı",
  "Çok Seçmeli": "Çok Seçmeli",
  "Çok Seçmeli (Onay Kutusu)": "Çok Seçmeli (Onay Kutusu)",
  "Çoğunlukla Açık": "Çoğunlukla Açık",
  "Özet": "Özet",
  "Öğrenim": "Öğrenim",
  "Ücretsiz izin": "Ücretsiz izin",
  "Ünvan": "Ünvan",
  "İki Aşamalı Doğrulama (2FA)": "İki Aşamalı Doğrulama (2FA)",
  "İlk Hareket": "İlk Hareket",
  "İndir": "İndir",
  "İnsan Kaynakları": "İnsan Kaynakları",
  "İptal": "İptal",
  "İyi Akşamlar 🌇": "İyi Akşamlar 🌇",
  "İyi Geceler 🌙": "İyi Geceler 🌙",
  "İzin": "İzin",
  "İzin Hakediş Tarihi": "İzin Hakediş Tarihi",
  "İzin Tür": "İzin Tür",
  "İzin Türü": "İzin Türü",
  "İzin Verilmedi": "İzin Verilmedi",
  "İzinli Gün": "İzinli Gün",
  "İş Başlangıç Tarihi": "İş Başlangıç Tarihi",
  "İş Yeri": "İş Yeri",
  "İşlem": "İşlem",
  "İşlemler": "İşlemler",
  "Şehir Bulunamadı": "Şehir Bulunamadı",
  "Şehir veya Ülke Seçiniz": "Şehir veya Ülke Seçiniz",
  "Şifre": "Şifre",
  "Şifre Değiştir": "Şifre Değiştir",
  "Şimdi Yenile": "Şimdi Yenile",
  "Şube": "Şube",
  "Zorunlu": "Zorunlu",
  "Yeni Kayıt": "Yeni Kayıt",
  "İş Giriş Çıkış Tanımları": "İş Giriş Çıkış Tanımları",
  "Kayıt bulunamadı.": "Kayıt bulunamadı.",
  "EBYS": "EBYS",
  "Onay Bekliyor": "Onay Bekliyor",
  "İmzalandı": "İmzalandı",
  "Sevk Edildi": "Sevk Edildi",
  "Tamamlandı": "Tamamlandı",
  "Hata oluştu": "Hata oluştu",
  "Kullanıcı Seçiniz": "Kullanıcı Seçiniz",
  "konu alanı gereklidir.": "Konu alanı gereklidir.",
  "Bildirimler": "Bildirimler",
  "Tümünü Okunmadı Olarak İşaretle": "Tümünü Okunmadı Olarak İşaretle",
  "Tümünü Okundu Olarak İşaretle": "Tümünü Okundu Olarak İşaretle",
  "Bildirim Bulunamadı!": "Bildirim Bulunamadı!",
  "Tüm Bildirimleri Gör": "Tüm Bildirimleri Gör",
  "Tüm Bildirimler": "Tüm Bildirimler",
  "Hiç bildiriminiz yok.": "Hiç bildiriminiz yok.",
  "Kategoriler": "Kategoriler",
  "Galeri": "Galeri",
  "Belge Bilgi Bankası": "Belge Bilgi Bankası",
  "Organizasyon": "Organizasyon",
  "Organizasyon Başlıkları": "Organizasyon Başlıkları",
  "Personel Dosyaları": "Personel Dosyaları",
  "Mesai Rapor": "Mesai Rapor",
  "Overall Rapor": "Genel Durum Rapor",
  "Kullanıcı Yetki Rapor": "Kullanıcı Yetki Rapor",
  "Fatura AI": "Fatura AI",
  "Destek Talepleri": "Destek Talepleri",
  "Telefon Rehberi": "Telefon Rehberi",
  "Bildirim Gönder": "Bildirim Gönder",
  "Pertentage Oparator Rapor": "Operatör Yüzde Raporu",
  "auth": {
    "Farklı bir hesapla giriş yap": "Farklı bir hesapla giriş yap"
  }
}
